import { type PropsWithChildren } from "react";

import { FocusTrap } from "@mantine/core";

import { SecondaryIconButton } from "../buttons";

interface Props {
  onClose: () => void;
}

export const DrawerHeader = ({
  children,
  onClose,
}: PropsWithChildren<Props>) => {
  return (
    <div className="flex items-center gap-2 text-v2-action font-semibold">
      <FocusTrap.InitialFocus />
      <SecondaryIconButton onClick={onClose}>
        <i className="fa-regular fa-arrow-right-to-line text-sm"></i>
      </SecondaryIconButton>
      <div>{children}</div>
    </div>
  );
};
